class StickyCta extends HTMLElement {
  constructor() {
    super();
    this.visible = null;
    this.scrollHandler = null;
    this.observer = null;
    this.resizeTimer = null;
  }

  connectedCallback() {
    this.button = this.querySelector('[data-sticky-cta-button]');
    if (!this.button) return;

    this.trigger = this.dataset.trigger || 'distance';
    this.distance = parseFloat(this.dataset.distance) || 100;
    this.selector = this.dataset.selector || '';
    this.behavior = this.dataset.behavior || 'link';

    this.setVisible(false, true);

    if (this.behavior === 'scroll_to_top') {
      this.button.addEventListener('click', this.handleScrollToTop.bind(this));
    }

    this.setupTrigger();
  }

  disconnectedCallback() {
    this.teardownTrigger();
  }

  setupTrigger() {
    if (this.trigger === 'selector' && this.selector) {
      const target = document.querySelector(this.selector);
      if (target && 'IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const isAbove = entry.boundingClientRect.bottom <= 0;
              this.setVisible(isAbove);
            });
          },
          { threshold: 0, rootMargin: '0px 0px 0px 0px' }
        );
        this.observer.observe(target);
        return;
      }
    }

    this.setupDistanceTrigger();
  }

  setupDistanceTrigger() {
    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const threshold = (window.innerHeight * this.distance) / 100;
        this.setVisible(window.scrollY >= threshold);
        ticking = false;
      });
    };
    this.scrollHandler = onScroll;
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    onScroll();
  }

  teardownTrigger() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
    if (this.scrollHandler) {
      window.removeEventListener('scroll', this.scrollHandler);
      window.removeEventListener('resize', this.scrollHandler);
      this.scrollHandler = null;
    }
  }

  handleScrollToTop(event) {
    event.preventDefault();
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: prefersReducedMotion ? 'auto' : 'smooth' });

    const mainContent = document.getElementById('MainContent');
    if (mainContent) {
      mainContent.setAttribute('tabindex', '-1');
      mainContent.focus({ preventScroll: true });
    }
  }

  setVisible(visible, force = false) {
    if (!force && this.visible === visible) return;
    this.visible = visible;
    this.classList.toggle('is-visible', visible);
    this.setAttribute('aria-hidden', String(!visible));
    if (this.button) {
      this.button.tabIndex = visible ? 0 : -1;
    }
  }
}

if (!customElements.get('sticky-cta')) {
  customElements.define('sticky-cta', StickyCta);
}
